import React from "react";
import { useSearchParams } from "react-router-dom";
import CustomPushTab from "../components/AdminNotifications/CustomPushTab";
import SegmentedPushTab from "../components/AdminSegmentedPush/SegmentedPushTab";

const TABS = [
  { key: "custom", label: "Custom push" },
  { key: "segmented", label: "Segmented push" },
] as const;

const AdminNotifications: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const requested = searchParams.get("tab");
  const activeTab = TABS.find((t) => t.key === requested) ?? TABS[0];

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-black/60">Send push</h2>
      </div>

      <div className="flex flex-wrap gap-1 mb-8 border-b border-gray-200">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setSearchParams({ tab: tab.key })}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
              tab.key === activeTab.key
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab.key === "segmented" ? <SegmentedPushTab /> : <CustomPushTab />}
    </div>
  );
};

export default AdminNotifications;
